import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_doc_approval_history_RowClass} from '../../../dbschema';

export class ClaimDocApprovalHistoryContainerModel extends BaseContainerModel {
  bl_aat_claim_doc_approval_history: bl_aat_claim_doc_approval_history_RowClass = new bl_aat_claim_doc_approval_history_RowClass();
}
